<!--
  Potenciální ohrožení lesa - doplňková mapová nástrojová nabídka 
-->
<template>

  <div class="d-flex flex-row" v-if="IsInit">


    <Teleport to="#MapLayerLegendDynamicObj" v-if="ViewLeg">

      <div v-if="MapScale < VybPohr.Legenda.EditableMinScale">

        <v-tooltip left v-if="MapScale < VybPohr.Legenda.EditableMinScale">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab small absolute right class="mr-3" color="info"
              @click="VybLegListSelectAll()">
              <v-icon v-if="VybLegList.length == 0">mdi-expand-all</v-icon>
              <v-icon v-else color="">mdi-collapse-all</v-icon>
            </v-btn>
          </template>
          <span v-if="VybLegList.length == 0">Vybrat vše</span>
          <span v-else>Odvybrat vše</span>
        </v-tooltip>

        <!-- Legenda s výběrem ( zobrazeno v měřítku pod VybPohr.Legenda.EditableMinScale) -->
        <v-list dense color="transparent">
          <v-list-item-group multiple v-model="VybLegList" color="primary">
            <v-list-item v-for="(item) in VybPohr.Legenda.Seznam" :key="item.Kod" :value="item.Kod">

              <!-- Se šrafou -->
              <v-list-item-avatar v-if="item.Srafa" class="my-1" rounded color="transparent">
                <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
                  <defs>
                    <!-- definice výplně - šrafy -->
                    <pattern :id="'pt_' + item.Kod" :width="item.Srafa.PatternWidth" :height="item.Srafa.PatternHeight"
                      patternUnits="userSpaceOnUse">
                      <path :d="item.Srafa.Pathd" style="stroke:currentColor"
                        :style="{ 'stroke-width': item.Srafa.PathdStyleStrokeWidth }">
                      </path>
                    </pattern>
                  </defs>
                  <!-- případná barva podkladu -->
                  <rect width="100%" height="100%" :fill="item.Srafa.BarvaPodklad" v-if="item.Srafa.BarvaPodklad" />
                  <!-- výplň - šrafa -->
                  <rect width="100" height="100" :fill="'url(#pt_' + item.Kod + ')'" />
                </svg>
              </v-list-item-avatar>

              <!-- Se šrafou z koleček-->
              <v-list-item-avatar v-else-if="item.SrafaCircle" class="my-1" rounded color="transparent">
                <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
                  <defs>
                    <!-- definice výplně - šrafy -->
                    <pattern :id="'ptc_' + item.Kod" :width="item.SrafaCircle.PatternWidth"
                      :height="item.SrafaCircle.PatternHeight" patternUnits="userSpaceOnUse">
                      <circle :cx="item.SrafaCircle.cx" :cy="item.SrafaCircle.cy" :r="item.SrafaCircle.r"
                        :fill="item.Barva" />
                    </pattern>
                  </defs>
                  <!-- případná barva podkladu -->
                  <rect width="100%" height="100%" :fill="item.SrafaCircle.BarvaPodklad"
                    v-if="item.SrafaCircle.BarvaPodklad" />
                  <!-- výplň - šrafa -->
                  <rect width="100" height="100" :fill="'url(#ptc_' + item.Kod + ')'" />
                </svg>
              </v-list-item-avatar>

              <!-- Bez šrafy -->
              <v-list-item-avatar v-else class="my-1" rounded :color="item.Barva" />

              <v-list-item-title v-text="item.Popis" class="white--text"></v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <div v-if="VybPohr.Legenda.Text">
          <div class="primary--text">Popis</div>
          <div class="text-body-2">{{ VybPohr.Legenda.Text }}</div>
        </div>

      </div>

      <div v-else>
        <!-- Legenda bez výběru ( zobrazeno v měřítku nad VybPohr.Legenda.EditableMinScale)  -->
        <v-list dense color="transparent">
          <v-list-item v-for="item in VybPohr.Legenda.Seznam" :key="item.Kod">

            <!-- Se šrafou -->
            <v-list-item-avatar v-if="item.Srafa" class="my-1" rounded color="transparent">
              <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
                <defs>
                  <!-- definice výplně - šrafy -->
                  <pattern :id="'pt_' + item.Kod" :width="item.Srafa.PatternWidth" :height="item.Srafa.PatternHeight"
                    patternUnits="userSpaceOnUse">
                    <path :d="item.Srafa.Pathd" style="stroke:currentColor"
                      :style="{ 'stroke-width': item.Srafa.PathdStyleStrokeWidth }">
                    </path>
                  </pattern>
                </defs>
                <!-- případná barva podkladu -->
                <rect width="100%" height="100%" :fill="item.Srafa.BarvaPodklad" v-if="item.Srafa.BarvaPodklad" />
                <!-- výplň - šrafa -->
                <rect width="100" height="100" :fill="'url(#pt_' + item.Kod + ')'" />
              </svg>
            </v-list-item-avatar>

            <!-- Se šrafou z koleček-->
            <v-list-item-avatar v-else-if="item.SrafaCircle" class="my-1" rounded color="transparent">
              <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
                <defs>
                  <!-- definice výplně - šrafy -->
                  <pattern :id="'ptc_' + item.Kod" :width="item.SrafaCircle.PatternWidth"
                    :height="item.SrafaCircle.PatternHeight" patternUnits="userSpaceOnUse">
                    <circle :cx="item.SrafaCircle.cx" :cy="item.SrafaCircle.cy" :r="item.SrafaCircle.r"
                      :fill="item.Barva" />
                  </pattern>
                </defs>
                <!-- případná barva podkladu -->
                <rect width="100%" height="100%" :fill="item.SrafaCircle.BarvaPodklad"
                  v-if="item.SrafaCircle.BarvaPodklad" />
                <!-- výplň - šrafa -->
                <rect width="100" height="100" :fill="'url(#ptc_' + item.Kod + ')'" />
              </svg>
            </v-list-item-avatar>

            <!-- Bez šrafy -->
            <v-list-item-avatar v-else class="my-1" rounded :color="item.Barva" />

            <v-list-item-title v-text="item.Popis"></v-list-item-title>
          </v-list-item>
        </v-list>

        <div v-if="VybPohr.Legenda.Text">
          <div class="primary--text">Popis</div>
          <div class="text-body-2">{{ VybPohr.Legenda.Text }}</div>
        </div>

      </div>

    </Teleport>


    <Teleport to="#MapUserSettingsObj">

      <v-switch dense class="mt-0" v-model="MapUserSettings_WfsHoverable" color="accent"
        :label="MapUserSettings_WfsHoverable ? 'Informace o objektu se zobrazují automaticky pod kurzorem.' : 'Informace o objektu se zobrazují po kliknutí.'">
      </v-switch>

    </Teleport>

  </div>
</template>

<script>
import AppPohr from "../../../assets/MapOt_Pohr.json";
import { eq, or, literal, property, toFeaturePredicate } from "@luciad/ria/ogc/filter/FilterFactory";

export default {

  components: {
    Teleport: () => import("vue2-teleport")
  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Viditelnost legendy
    MapLayerLegend_view: null,
    // Jméno zobrazené dynamické legendy
    MapLayerLegendDynamic_content: {},

  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,
      // Seznam vrstev
      PohrList: [],
      // Vybraná vrstva
      VybPohr: {
        "id": "",
        "Name": "",
        "Popis": "",
        "LayerGroup": "",
        "LayerTile": "",
        "LayerWfs": "",
        "Legenda": [],
        "VybLegList": [],
      },

      // Vybrané prvky vybrané legendy
      VybLegList: [],

      // Viditelnost legendy
      ViewLeg: false,

      // Informace o objektu automaticky pod kurzorem nebo na kliknutí
      MapUserSettings_WfsHoverable: true,

    };
  },



  computed: {
    // Vrstva LayerGroup z mapy určené pro vybranou vrstvu
    MapLayer_Pohr_Group: function () {
      return this.MapLegendLayers.find((item) => item.id == this.VybPohr.LayerGroup);
    },
    // Podřízená vrstvy - tile
    MapLayer_Pohr_tile: function () {
      return this.MapLegendLayers.find((item) => item.id == this.VybPohr.LayerTile);
    },
    // Podřízená vrstvy - wfs
    MapLayer_Pohr_wfs: function () {
      return this.MapLegendLayers.find((item) => item.id == this.VybPohr.LayerWfs);
    },

    // wfs vrstva - filter podle výběru
    MapLayer_pohr_wfs_Filter: function () {
      if (this.VybPohr.id == "Pohr_iles_bovs_legend") {
        // Legenda obsahuje skupiny kódů

        if (this.VybPohr.Legenda.Seznam.length == this.VybLegList.length) {
          // Všechny položky
          return null

        } else if (this.VybLegList.length == 0) {
          // žádná položka - rovno neexistující hodnotě
          return toFeaturePredicate(eq(property(this.VybPohr.Legenda.Polozka), literal('xxxxxxxx')));

        } else if (this.VybLegList.length == 1) {
          // Jedna skupina položek

          //console.log("VybLegList.length = 1")

          var _this = this;
          var filters = this.VybPohr.Legenda.Seznam.find((item) => item.Kod == this.VybLegList[0]).KodSeznam.map(function (l) {
            return (eq(property(_this.VybPohr.Legenda.Polozka), literal(l)))
          })

          //console.log(filters)
          if (filters.length == 1) {
            return toFeaturePredicate(filters[0]);
          } else {
            return toFeaturePredicate(or(...filters));
          }

        } else {

          //console.log("VybLegList.length > 1")
          var _this1 = this;
          var filters1 = this.VybLegList.map(function (l) {
            return _this1.VybPohr.Legenda.Seznam.find((item) => item.Kod == l).KodSeznam
          }).flat().map(function (l) {
            return (eq(property(_this1.VybPohr.Legenda.Polozka), literal(l)))
          })
          //console.log(filters1)
          return toFeaturePredicate(or(...filters1));
        }

      } else {

        if (this.VybPohr.Legenda.Seznam.length == this.VybLegList.length) {
          // Všechny položky
          return null

        } else if (this.VybLegList.length == 0) {
          // žádná položka - rovno neexistující hodnotě
          return toFeaturePredicate(eq(property(this.VybPohr.Legenda.Polozka), literal('xxxxxxxx')));

        } else if (this.VybLegList.length == 1) {
          // Jedna položka
          return toFeaturePredicate(eq(property(this.VybPohr.Legenda.Polozka), literal(this.VybLegList[0])));

        } else {

          var _this3 = this;
          var filters3 = this.VybLegList.map(function (l) {
            return (eq(property(_this3.VybPohr.Legenda.Polozka), literal(l)))
          })

          return toFeaturePredicate(or(...filters3));
        }

      }


    },


  },

  watch: {
    // Inicializace
    IsInit: function () {
      // console.log("IsInit");
      // console.log(value);
      this.MapUserSettingsButtonView(true);

    },

    // Změna zobrazení jednotlivých objektů v legendě
    VybLegList: function () {
      //console.log("VybLegList");
      this.MapLayer_Pohr_wfs.layer.filter = this.MapLayer_pohr_wfs_Filter;
    },

    // Změna zobrazení vlastní legendy
    MapLayerLegendDynamic_content: function (value) {
      // console.log("MapLayerLegendDynamic_content")
      // console.log(value)

      if (value == null) {
        this.ViewLeg = false
      } else {
        if (this.PohrList.find((item) => item.id == value)) {
          // Uložení předchozího výběru legendy
          if (this.VybPohr.id != "") {
            // console.log("Uložení předchozího výběru legendy")
            this.VybPohr.VybLegList = this.VybLegList
          }

          this.VybPohr = this.PohrList.find((item) => item.id == value)
          this.VybLegList = this.VybPohr.VybLegList
          this.ViewLeg = true
        }
      }
    },


    // Změna informací pod kursorem
    MapUserSettings_WfsHoverable: function (value) {
      // console.log("MapUserSettings_WfsHoverable")
      // console.log(value)

      // AppIles.MapLayers.Uhul_iles_wfs.featureOptions.hoverable = value;
      // AppIles.MapLayers.Uhul_iles_wfs.featureOptions.selectable = !value;

      this.MapLayer_Pohr_wfs.layer.hoverable = value;
      this.MapLayer_Pohr_wfs.layer.selectable = !value;

    },




  },

  methods: {

    // Viditelnost tlačítka pro dialog s nastavením
    MapUserSettingsButtonView: function (value) {
      //console.log("MapLayerLegendDynamicSet")
      this.$emit('MapUserSettingsButtonView', value);
    },


    // Vybrat vše v legendě (když počet nula) jina odvybrat vše
    VybLegListSelectAll: function () {
      if (this.VybLegList.length == 0) {
        this.VybLegList = this.VybPohr.Legenda.Seznam.map(function (l) {
          return l.Kod
        })
      } else {
        this.VybLegList = []
      }

    },

  },

  mounted() {
    // První spuštění nástroje
    // console.log("POHR start");
    // Základní nastavení
    this.PohrList = AppPohr.PohrList;
    // Pro všechno vybrat všechny prvky
    this.PohrList.forEach((item) => { item.VybLegList = item.Legenda.Seznam.map((l) => l.Kod) })

    // Objekt aktivován
    this.MAP.layerTree.whenReady().then(() => { this.IsInit = true; })

  },
};
</script>